import styled, { css } from 'styled-components';
import Grid from '@material-ui/core/Grid';

export const Wrapper = styled.footer`
  z-index: 1;
  box-sizing: border-box;
  background: #ffffff;
  border-top: 1px solid #f1f5f9;
  color: #94a3b8;
  padding: 10px 20px;

  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.up('md')} {
      justify-content: flex-start;
      border-top: 1px solid #e2e8f0;
      color: #64748b;
    }
    ${mui.breakpoints.only('md')} {
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 3;
    }
    ${mui.breakpoints.down('xs')} {
      position: fixed;
      bottom: 0;
      z-index: 3;
      width: 100%;
    }
  `}

  svg {
    opacity: 0.6;
    height: 16px;
    width: auto;
  }

  @media (min-width: 768px) {
    svg {
      opacity: 1;
      height: auto;
    }
  }
`;

export const Container = styled.div`
  align-items: center;
  color: ${({ theme: { color } }) => color.white_500};
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;
  margin: auto;
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.up('sm')} {
      max-width: 75%;
    }
  `}
  ${({ theme: { mui } }) => css`
    ${mui.breakpoints.down('sm')} {
      max-width: 442px;
    }
  `}
`;

export const LogoContent = styled(Grid)`
  && {
    svg {
      margin-right: 8px;
    }
  }
`;
